import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { BeatLoader } from 'react-spinners'
import { Box, Text } from './theme'

const IsLoading = ({ isLoading }) => (
  <Fragment>
    {isLoading && (
      <Box>
        <BeatLoader />
      </Box>
    )}
  </Fragment>
)

const ErrorMessage = ({ errMessage }) => (
  <Fragment>
    {'' !== errMessage && (
      <Box>
        <Text>Błąd: {errMessage}</Text>
      </Box>
    )}
  </Fragment>
)

IsLoading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
}
ErrorMessage.propTypes = {
  errMessage: PropTypes.string.isRequired,
}

export { IsLoading, ErrorMessage }



// WEBPACK FOOTER //
// ./src/components/LoadingOrErrorCollection/index.js